import {
	GradientText,
	SubText,
	Wrapper,
} from '../PasserCommande/PasserCommande.styles'
import React, { useEffect, useState } from 'react'
import {
	searchCommandesByDateForClient,
	searchCommandesByPrixMinMaxForClient,
	searchCommandesByIdForClient,
} from '../../api/clients'

import Container from '../../Components/LayoutClient/container.component'
import CourseACourseHorizontal from '../../Components/SingleCommandeHorizontal/CourseACourseHorizontal'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import MiseADispoHorizontal from '../../Components/SingleCommandeHorizontal/MiseADispoHorizontal'
import Select from 'react-select'
import { getAllCommandesByClientIdForHistorique } from '../../api/commande'
import moment from 'moment'
import { useHistory } from 'react-router'
import { useSelector } from 'react-redux'
import toast from 'react-hot-toast'
import UltimatePaginationBasic from '../../Components/Pagination/Pagination'
import { mergeInvoiceForCommande } from '../../api/invoice'
import DetailCommandeModal from '../../Components/DetailCommande/DetailCommandeModal'
import { useAuthenticatedFetch } from '../../hooks'
import { useTranslation } from 'react-i18next'

const SIZE = 10

function Historique() {
	const history = useHistory()
	const [commandes, setCommandes] = useState([])

	const clientID = useSelector((state) => state.auth.user._id)
	const token = useSelector((state) => state.auth.token)

	const [page, setPage] = useState(1)
	const [totalPages, setTotalPages] = useState(1)

	const [isSearching, setIsSearching] = useState(false)

	const [searchCriteria, setSearchCriteria] = useState('id')
	const [range, setRange] = useState([new Date(), new Date()])
	const [min, setMin] = useState(0)
	const [max, setMax] = useState(300)

	const [modalIsOpenDetail, setModalIsOpenDetail] = useState(false)

	const [selectedCommande, setSelectedCommande] = useState(null)
	const [chargementEnCours, setChargementEnCours] = useState(false)
	const [searchQueryId, setSearchQueryId] = useState('')
	const {t} = useTranslation();
	const [selectedOption, setSelectedOption] = useState({
		value: 'id',
		label: t("search_by_id"),
	})
	const handleChange = (selectedOption) => {
		setSelectedOption(selectedOption)
		setSearchCriteria(selectedOption.value)
	}

	const fetchCommandes = async (page) => {
		setChargementEnCours(true)
		try {
			let res
			if (isSearching) {
				if (searchCriteria === 'id') {
					res = await searchCommandesByIdForClient(
						clientID,
						searchQueryId,
						'historique',
						token,
						page,
						SIZE
					)
				} else if (searchCriteria === 'prix') {
					res = await searchCommandesByPrixMinMaxForClient(
						min,
						max,
						clientID,
						'historique',
						token,
						page,
						SIZE
					)
				} else if (searchCriteria === 'date') {
					let minDate = moment(range[0]).format()
					let maxDate = moment(range[1]).format()
					let offsetUTC = moment().format('Z')

					res = await searchCommandesByDateForClient(
						minDate,
						maxDate,
						clientID,
						'historique',
						token,
						page,
						SIZE,
						offsetUTC
					)
				}
			} else {
				res = await getAllCommandesByClientIdForHistorique(
					clientID,
					token,
					page,
					SIZE
				)
			}
			setCommandes(res.commandes)
			setTotalPages(res.totalPages)
		} catch (error) {
			toast.error(t("transfer_request_err"), {
				style: {
					fontFamily: 'Montserrat',
				},
			})
		} finally {
			setChargementEnCours(false)
		}
	}

	const resetData = async () => {
		setIsSearching(false)
		setSearchQueryId('')
		setSearchCriteria('id')
		setSelectedOption({
			value: 'id',
			label: t("search_by_id"),
		})
		setPage(1)
	}

	const handleSearch = () => {
		setIsSearching(true)
		setPage(1)
		if (isSearching) {
			fetchCommandes(1)
		}
	}

	const {
		fetchResource,
		error: fetchError,
		loading: fetchLoading,
	} = useAuthenticatedFetch()

	const handleViewInvoices = async (id) => {
		try {
			const res = await mergeInvoiceForCommande(id, token)
			const fileBlob = await fetchResource(res.mergedPdfPath, token)
			if (fetchError) {
				toast.error(t("unable_to_retrieve_invoice"), {
					style: {
						fontFamily: 'Montserrat',
					},
				})
				console.error('Failed to fetch the facture', fetchError)
			}

			window.open(fileBlob)
		} catch (error) {
			console.log(error)
			toast.error(t("unable_to_retrieve_invoice"), {
				style: {
					fontFamily: 'Montserrat',
				},
			})
		}
	}
	useEffect(() => {
		fetchCommandes(page)
	}, [page, isSearching])
	const [isMobile, setMobile] = useState(() => window.innerWidth < 768);


	useEffect(() => {
		const checkIfMobile = () => {
			setMobile(window.innerWidth < 768);
		};
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);
	return (
		<Container>
			<Wrapper>
				<GradientText style={{ fontSize: isMobile ? '2rem' : '2.5rem' }}>
					{t("history").toUpperCase()}</GradientText>
				<SubText>
					{t("history_subtext")}
				</SubText>

				<div
					style={{
						width: '100%',
						fontFamily: 'Montserrat',
						marginBottom: '2rem',
						marginTop: '1rem',
						display: 'flex',
						flexDirection: isMobile ? 'column' : 'row',
						gap: isMobile ? '10px' : '0'
					}}
				>
					<div
						style={{
							width: isMobile ? '100%' : '350px',
							fontFamily: 'Montserrat',
							marginRight: isMobile ? 0 : '1rem',
						}}
					>
						<Select
							isSearchable={false}
							options={[
								{
									value: 'id',
									label: t("search_by_id"),
								},
								{ value: 'prix', label: t("price") },
								{ value: 'date', label: t("transport_date") },
							]}
							styles={{
								option: (provided, state) => ({
									...provided,
									fontFamily: 'Montserrat',
								}),
								control: (provided, state) => ({
									...provided,
									height: '3rem',
									minHeight: 'fit-content',
								}),
								valueContainer: (base) => ({
									...base,
									maxHeight: '3rem',
									fontSize: isMobile ? '14px' : '16px',
								}),
							}}
							value={selectedOption}
							onChange={handleChange}
							menuPortalTarget={document.querySelector('body')}
						/>
					</div>
					{searchCriteria === 'id' ? (
						<input
							style={{
								padding: '0.4rem',
								borderRadius: 5,
								border: '1px solid #E4EAF0',
								height: '3rem',
								width: isMobile ? '100%' : '20rem',
								fontFamily: 'Montserrat',
							}}
							value={searchQueryId}
							onChange={(e) => setSearchQueryId(e.target.value)}
							placeholder={t("search")}
						/>
					) : null}
					{searchCriteria === 'prix' ? (
						<>
							<input
								type='number'
								style={{
									padding: '0.4rem',
									borderRadius: 5,
									border: '1px solid #E4EAF0',
									height: '3rem',
									width: isMobile ? '100%' : '20rem',
									fontFamily: 'Montserrat',
									marginRight: '1rem',
								}}
								value={min}
								onChange={(e) => {
									setMin(Number(e.target.value))
								}}
								placeholder='Prix min'
							/>
							<input
								type='number'
								style={{
									padding: '0.4rem',
									borderRadius: 5,
									border: '1px solid #E4EAF0',
									height: '3rem',
									width: isMobile ? '100%' : '20rem',
									fontFamily: 'Montserrat',
								}}
								value={max}
								onChange={(e) => {
									setMax(Number(e.target.value))
								}}
								placeholder='Prix max'
							/>
						</>
					) : null}

					{searchCriteria === 'date' ? (
						<DateRangePicker onChange={setRange} value={range} />
					) : null}

					<button
						onClick={handleSearch}
						style={{
							padding: '0.6rem 1rem',
							height: '3rem',
							background: '#C9D5F7',
							border: 'none',
							cursor: 'pointer',
							color: '#1C63C5',
							borderRadius: 7,
							//marginTop: 20,
							marginLeft: isMobile ? '0' : '1rem',
							width: isMobile ? '100%' : '',
							fontFamily: 'Montserrat',
							fontWeight: 'bold',
						}}
					>
						{t("search")}
					</button>

					<button
						onClick={resetData}
						style={{
							padding: '0.6rem 1rem',
							height: '3rem',
							background: '#C9D5F7',
							border: 'none',
							cursor: 'pointer',
							color: '#1C63C5',
							borderRadius: 7,
							marginRight: isMobile ? '0' : '1rem',
							marginLeft: isMobile ? '0' : '1rem',
							fontFamily: 'Montserrat',
							fontWeight: 'bold',
							width: isMobile ? '100%' : ''
						}}
					>
						{t("clear")}
					</button>
				</div>
				{chargementEnCours ? (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							backgroundColor: 'white',
							marginTop: '3rem',
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
						}}
					>
						<div className='customLoader'></div>
					</div>
				) : (
					<div
						style={{
							width: '100%',
							fontFamily: 'Montserrat',
							marginBottom: 5,
						}}
					>
						{' '}
						{commandes.length === 0 ? (
							<span
								style={{
									display: 'flex',
									textAlign: 'center',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								{t("no_orders_msg")}
							</span>
						) : (
							commandes.map((commande) => {
								if (
									commande.type_commande === 'course-a-course'
								) {
									return (
										<CourseACourseHorizontal
											key={commande._id}
											commande={commande}
											hideRecu
											hideAttribuer
											hidecancel
											hidefacture
											hideStatus
											hideUpdate
											hideFile
											onClickDetails={() => {
												setSelectedCommande(
													commande._id
												)
												setModalIsOpenDetail(true)
											}}
											onClickSignaler={() => {
												history.push(
													`/client/transports/${commande._id}/signaler`
												)
											}}
										/>
									)
								} else {
									return (
										<MiseADispoHorizontal
											key={commande._id}
											commande={commande}
											hideRecu
											hideAttribuer
											hidecancel
											hideUpdate
											hideStatus
											hideFile
											onClickDetails={() => {
												setSelectedCommande(
													commande._id
												)
												setModalIsOpenDetail(true)
											}}
											onClickSignaler={() => {
												history.push(
													`/transports/${commande._id}/single`
												)
											}}
											onClickMissions={() => {
												history.push(
													`/client/transports/missions/${commande._id}`
												)
											}}
											onClickFacture={() => {
												handleViewInvoices(commande._id)
											}}
										/>
									)
								}
							})
						)}
					</div>
				)}
				<div
					style={{
						width: '100%',
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						justifyContent: 'center',
						marginBottom: '3rem',
						marginTop: '3rem',
					}}
				>
					<UltimatePaginationBasic
						currentPage={page}
						totalPages={totalPages}
						onChange={(newPage) => setPage(newPage)}
					/>
				</div>
			</Wrapper>
			<DetailCommandeModal
				isOpen={modalIsOpenDetail}
				onClose={() => setModalIsOpenDetail(false)}
				commandeId={selectedCommande}
			/>
		</Container>
	)
}

export default Historique
